import ReactDatePicker from "react-datepicker";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import { CalendarIcon } from "@chakra-ui/icons";
import "react-datepicker/dist/react-datepicker.css";
import React, { forwardRef } from "react";
import MaskedInput from "react-input-mask";

const icon = <CalendarIcon fontSize="sm" />;

function customDateInput({ value, onClick, onChange, isdisabled, mask }, ref) {
  return (
    <>
      <MaskedInput
        mask={mask}
        value={value}
        onChange={onChange}
        disabled={isdisabled}
      >
        {(inputProps) => (
          <Input
            {...inputProps}
            autoComplete="off"
            background="white"
            onClick={onClick}
            onChange={onChange}
            ref={ref}
            disabled={isdisabled}
          />
        )}
      </MaskedInput>
      {!isdisabled && (
        <InputRightElement color="gray.500" children={icon} onClick={onClick} />
      )}
    </>
  );
}
customDateInput.displayName = "DateInput";
const CustomInput = forwardRef(customDateInput);

const DatePickerInput = forwardRef(({
  selectedDate,
  onChange,
  placeholder,
  disabled,
  showTimeSelect,
  showTimeSelectOnly,
  minDate,
  isShowMinDate = false,
  mask,
  onCalendarOpen,
  // support Controller which may pass `value` and other field props
  value,
  selected,
  ...props
}, ref) => {
  // Chọn mask phù hợp với kiểu date/time
  const inputMask = !showTimeSelect ? "99/99/9999" : showTimeSelectOnly ? "99:99" : "99/99/9999 99:99";
  // prefer selectedDate prop, then selected, then value (Controller provides value)
  const selectedValue = selectedDate != null ? selectedDate : (selected != null ? selected : (value != null ? value : null));

  return (
    <InputGroup className="dark-theme">
      <ReactDatePicker
        selected={selectedValue}
        onChange={onChange || props.onChange}
        className="react-datapicker__input-text"
        // pass the forwarded ref down to the custom input so Controller refs work
        customInput={<CustomInput ref={ref} isdisabled={disabled} mask={inputMask} />}
        dateFormat={
          !showTimeSelect
            ? "dd/MM/yyyy"
            : showTimeSelectOnly
            ? "HH:mm"
            : "dd/MM/yyyy HH:mm a"
        }
        {...props}
        showTimeSelect={showTimeSelect}
        timeIntervals={15}
        minDate={!isShowMinDate ? minDate || new Date() : undefined}
        showTimeSelectOnly={showTimeSelectOnly}
        yearDropdownItemNumber={5}
        showYearDropdown
        calendarStartDay={1}
        onCalendarOpen={onCalendarOpen}
      />
    </InputGroup>
  );
});

export default DatePickerInput;
